import { hasEnabled } from '@debbie/common/dist/feature-flags/index.js';
import { selectMe } from '@debbie/cortex/dist/me/selectors.js';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js';
import { useSelector } from 'react-redux';
export const useVariation = (flag, loadingValue = false) => {
    const tenant = useSelector(selectTenant);
    const me = useSelector(selectMe);
    if (!tenant || !me) {
        return loadingValue;
    }
    // TODO(fq): add feature flags to user as well
    return hasEnabled(flag, tenant);
};
//# sourceMappingURL=index.js.map